import React, { useState, Suspense } from "react";
import { styled } from "../../stitches.config";
import { h2, bodyLarge, h4Strong } from "../commonStyles/Fonts";
import { ReactComponent as Arrow } from "../assets/icons/arrow-right.svg?react";
import { ReactComponent as StarEmpty } from "../assets/icons/subscribe-star-empty.svg?react";
import SubscribeButton from "../SubscribeButton";
import { useWindowWidth } from "../../helpers/useWindowWidth";
import { useAuth } from "../../context/AuthContext";
import News from "../../components/composition-components/box/News";
import Stitches from "@stitches/react";
import CategoryInfoSign from "../components/CategoryInfoSign";
import { DISABLE_PREMIUM_FLAG_ACTIVE } from "../../components/common/constants/constants"


//import CategoryInfoSign from "../components/CategoryInfoSign"
const HeadingTitle = React.lazy(() => import(/* webpackChunkName: "redesign__atoms__HeadingTitle" */ './HeadingTitle'));


interface HeadingProps {
  title: string;
  url?: string;
  btnSubscribe?: boolean;
  amount?: string;
  style?: string;
  subscribe?: boolean;
  specialHeading?: boolean;
  specialHeadingStyle?: "specialDots" | "fullDots" | "withoutDots";
  subscribeSection?: string;
  showMore?: boolean;
  infoSignText?: string;
  hiddenDots?: boolean;
}

const Heading: React.FC<HeadingProps> = ({
  title,
  url,
  btnSubscribe = false,
  amount,
  style = "",
  subscribe = false,
  specialHeading = false,
  specialHeadingStyle = "fullDots",
  subscribeSection = "",
  showMore = true,
  infoSignText,
  hiddenDots = false,
  ...props
}) => {
  const [isActive, setActive] = useState(subscribe);
  //const [{ user }] = useAuth();

  const toggleClass = () => {
    setActive(!isActive);
  };

  const dotsStyle = specialHeadingStyle;

  let titleElement = <>{title}</>;
  if (url)
    titleElement = <a href={url}>{title}</a>;

  return (
    <div>
      <Suspense fallback={null}>
        <HeadingTitle
          title={title}
          url={url}
          btnSubscribe={btnSubscribe}
          amount={amount}
          style={style}
          subscribe={subscribe}
          specialHeading={specialHeading}
          specialHeadingStyle={specialHeadingStyle}
          subscribeSection={subscribeSection}
          showMore={showMore}
          infoSignText={infoSignText}
          hiddenDots={hiddenDots}
        />
      </Suspense>
    </div >
  );
};

const StyledHeading = styled("div", {
  width: "100%",
  display: "flex",
  variants: {
    special: {
      true: {
        alignItems: "center",
        "&.style--default-white": {
          color: "white",
          "span, a": {
            color: "white",
          }
        },
        "&.style--center-white": {
          color: "white",
          "span, a": {
            color: "white",
            textAlign: "center",
          }
        },
        "&.style--center-black": {
          color: "$grayscale100",
          "span, a": {
            color: "$grayscale100",
            textAlign: "center",
          }
        },
      },
      false: {
        justifyContent: "space-between",
        margin: "0 0 25px",
        "@bp4": {
          margin: "40px 0",
        }
      }
    }
  },
  // dodatkowe style dla Category, Category6
  "&.style--category-center-black": {
    "& .heading-title": {
      justifyContent: "flex-start",
      "@bp4": {
        justifyContent: "space-between",
        width: "100%",
      }
    },
    "span": {
      textAlign: "center",
      color: "$grayscale100",
    }
  },
  "&.style--category-center-white": {
    "& .heading-title": {
      justifyContent: "flex-start",
      "@bp4": {
        justifyContent: "space-between",
        width: "100%",
      }
    },
    "span": {
      textAlign: "center",
      color: "$grayscale0Fixed",
    }
  },
  "&.style--category-default-white": {
    "& .heading-title": {
      justifyContent: "flex-start",
    },
    "span": {
      color: "$grayscale0Fixed",
    }
  },
  "&.style--category-default-dark": {
    "& .heading-title": {
      justifyContent: "flex-start",
    },
  },
});

const StyledTitle = styled("div", {
  position: "relative",
  width: "100%",
  letterSpacing: "0px",
  display: "flex",
  "@bp4": {
    fontSize: "38px",
    lineHeight: "42px"
  },
  "& > span": {
    marginRight: "12px",
    color: "$grayscale100",
  },
  "a,a:focus,a:hover": {
    color: "inherit",
    textDecoration: "inherit"
  },
  variants: {
    special: {
      true: {
        padding: "0 0 12px",
        "& p": {
          width: "100%",
          textAlign: "center",
          margin: 0,
        },
        "& .hidden-dots-span": {
          width: "100%",
          textAlign: "center",
          display: "block",
        },
        "@bp4": {
          padding: "40px 0"
        }
      },
      false: {
        margin: 0,
        paddingLeft: 0,
        justifyContent: "flex-start",
        alignItems: "center",
        "@bp4": {
          width: "auto",
          marginBottom: "3px",
        },
      }
    },
    dots: {
      fullDots: {
        justifyContent: "flex-start"
      },
      specialDots: {
        justifyContent: "flex-start",
        "@bp3": {
          justifyContent: "space-between",
        },
      },
      withoutDots: {}
    },
  },
  defaultVariants: {
    special: false
  }
});

const StyledBtnMore = styled("a", {
  color: "$primary",
  position: "relative",
  background: "none",
  borderWidth: "0px",
  display: "none",
  alignItems: "center",
  textDecoration: "none",
  fontWeight: "600",
  "&:hover": {
    color: "$primary120",
    textDecoration: "none",
  },

  "&:active": {
    color: "$primary",
    textDecoration: "none",
  },

  "@bp4": {
    display: "flex",
  },
  "& span": {
    content: "",
    // height: "10px",
    width: "14px",
    marginLeft: "6px",
  },
  "& svg": {
    marginLeft: "6px",
    position: "relative",
    top: "1px",
    "& path": {
      fill: "$primary",
    }
  },
});

const Dots = styled("div", {
  position: "relative",
  width: "8px",
  marginRight: "8px",
  flexShrink: 0,
  "&:after,&:before": {
    boxSizing: "border-box",
    content: "",
    position: "absolute",
    height: "8px",
    width: "100%",
    borderRadius: "50%",
    backgroundColor: "$primary",
    "@bp4": {
      height: "12px",
    },
  },
  "@bp4": {
    width: "12px",
    marginRight: "12px",
  },
  variants: {
    type: {
      normal: {
        marginRight: "8px",
        "@bp4": {
          marginRight: "12px",
        }
      },
      empty: {
        marginRight: '0px',
        display: "none",
        "&:after,&:before": {
          backgroundColor: "transparent",
          border: "1px solid $primary",
        },
        "@bp3": {
          display: "block"
        }
      }
    },
    special: {
      true: {
        height: "42px",
        "&:after": {
          top: "8px",
          left: "0px",
          "@bp4": {
            top: "6px",
          }
        },
        "&:before": {
          top: "20px",
          left: "0px",
          "@bp4": {
            top: "24px",
          }
        }
      },
      false: {
        height: "100%",
        "&:before": {
          left: "0px",
          top: "18px",
          "@bp4": {
            top: "24px",
          }
        },
        "&:after": {
          left: "0px",
          top: "8px",
        },
      }
    }
  }
});

const StyledAmount = styled("button", {
  marginLeft: "12px",
  padding: "4px 8px",
  border: "1px solid $grayscale25",
  display: "flex",
  alignItems: "center",
  background: "none",
  "& svg": {
    fill: "$primary",
    marginRight: "4px",
  },
});

export default Heading;